import React, { useState, useEffect } from "react";
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Typography,
  Button,
  Divider,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Delete from "@material-ui/icons/Delete";
import { useForm } from "react-hook-form";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 6),
    borderRadius: "8px",
    outline: "none",
    width: "600px",
  },
  fileInput: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const AdjuntoComentario = ({
  onClose,
  tarjeta,
  setCargando,
  setMensaje,
  onFileAdded,
  key,
  fileAdjunto,
  index,
  adjuntoComentario,
  setAdjuntoComentario,
}) => {
  const classes = useStyles();
  const [selectedFile, setSelectedFile] = useState(null);
  const { setValue } = useForm(); // Añadido formState para errores

  const getFile = (data, mimeType) => {
    if (!data) return null;

    if (typeof data == "string") {
      let link = document.createElement("a");
      // TOMAMOS LA INFORMACION EN BASE64
      const binaryString = atob(data);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i += 1) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      const blob1 = new Blob([bytes], { type: mimeType });
      return blob1;
    } else return data;
  };

  const [file, setFile] = useState(
    getFile(fileAdjunto?.data, fileAdjunto?.mimeType)
  );

  const getPreview = (data, mimeType) => {
    if (!data) return null;
    if (typeof data == "string") {
      let link = document.createElement("a");
      // TOMAMOS LA INFORMACION EN BASE64
      const binaryString = atob(data);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i += 1) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      const blob1 = new Blob([bytes], { type: mimeType });
      link.href = URL.createObjectURL(blob1);

      return link.href;
    }

    return URL.createObjectURL(data);
  };

  const [previewUrl, setPreviewUrl] = useState(
    getPreview(fileAdjunto?.data, fileAdjunto?.mimeType)
  );

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile); // Guardamos el archivo en el estado
      setValue("file", selectedFile); // Actualiza el valor en react-hook-form
      const fileUrl = URL.createObjectURL(selectedFile);
      setPreviewUrl(fileUrl);

      //change array
      let fileOriginal = adjuntoComentario.files;
      fileOriginal[index] = { data: selectedFile };
      setAdjuntoComentario({ ...adjuntoComentario, files: fileOriginal });
    }
  };
  const handleClearPreview = () => {
    setFile(null); // Limpia el archivo del estado
    setValue("file", null); // Limpia el valor en react-hook-form
    setPreviewUrl(null);
  };

  const handleDelete = (indexBtn) => () => {
    let currentFiles = adjuntoComentario?.files || [];
    currentFiles.splice(indexBtn, 1);

    let currentFile = adjuntoComentario?.files[index];
    setFile(getFile(currentFile?.data, currentFile?.mimeType));
    setPreviewUrl(getPreview(currentFile?.data, currentFile?.mimeType));

    setAdjuntoComentario({ open: true, files: currentFiles });
  };

  return (
    <Box key={"box_" + index} style={{ margin: "5px" }}>
      <input
        type="file"
        accept="image/*,.pdf"
        onChange={handleFileChange}
        style={{ display: "none" }}
        id={"file-input_" + index}
      />
      <label htmlFor={"file-input_" + index}>
        <Button
          variant="contained"
          color="#FFFFFF"
          component="span"
          style={{ margin: "10px" }}
        >
          Seleccionar archivo {" (" + (index + 1) + ")"}*
        </Button>
      </label>
      <Button
        variant="contained"
        component="span"
        style={{
          margin: "10px",
          backgroundColor: "#d32f2f",
          color: "#FFFFFF",
        }}
        onClick={handleDelete(index)}
      >
        <Delete />
      </Button>

      {file && ( // Cambiado "selectedFile" por "file"
        <>
          <Typography variant="body1" style={{ color: "white" }}>
            Archivo {" (" + (index + 1) + ") "} seleccionado: {file.name} {fileAdjunto.nombre}
          </Typography>
          {file.type.startsWith("image/") ? (
            <img
              src={previewUrl}
              alt="Vista previa"
              style={{
                width: "100%",
                maxHeight: "400px",
                marginTop: "10px",
              }}
              id={"preview_img_" + index}
            />
          ) : (
            <iframe
              src={previewUrl}
              title="Vista previa de PDF"
              style={{ width: "100%", height: "400px", marginTop: "10px" }}
              id={"preview_frame_" + index}
            />
          )}
          <Grid container justifyContent="center" spacing={2} gap={3}>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClearPreview}
                style={{ marginTop: "10px" }}
              >
                Limpiar selección {" (" + (index + 1) + ")"}
              </Button>
            </Grid>
            {/* <Grid item>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleSubmit}
                style={{ marginTop: "10px" }}
              >
                Subir
              </Button>
            </Grid> */}
          </Grid>
        </>
      )}
      <Divider style={{ backgroundColor: "gray", marginTop: "5px" }} />
    </Box>
  );
};

export default AdjuntoComentario;
